import { edgeFunctionData } from '../../services/edgeFunctionData';
import {
  fetchHoursAfterEnd,
  fetchLateTimesheets,
  fetchLateWorklogs,
  setLateHoursSeen,
} from '../../services/phaseEndAlerts';
import { notify } from '../../store/feedback';
import { fmtDate } from '../../utils/format';
import { phaseBrickId } from '../../utils/phases';

/* Alerte de fin de phase (arbitrage du 02/10/2026) : une phase close dès sa date de fin ne compte
   plus les heures qui arrivent ensuite. On les signale, on prolonge la phase, ou on la laisse close
   (l'alerte revient si de nouvelles heures arrivent). */
export default function phaseEndAlertsHandlers(deps, api) {
  const { setLateDetails, setLateHoursByPhase, setPhaseEndDialog, update } = deps;

  async function loadLateHours() {
    const { data, error } = await fetchHoursAfterEnd();
    // Fonction absente tant que la migration 016 n'est pas passée : pas d'alerte, pas d'erreur.
    if (error) return;
    const entries = (data || []).map((r) => [
      r.phase_id,
      { heures: Number(r.heures), derniereDate: String(r.derniere_date).slice(0, 10) },
    ]);
    setLateHoursByPhase(Object.fromEntries(entries));
  }

  async function loadLateDetails(phase) {
    setLateDetails((d) => ({ ...d, [phase.id]: { loading: true } }));
    const brickIds = [phaseBrickId(phase.id), ...(phase.briques || []).map((b) => b.id)];
    const [lines, jira] = await Promise.all([
      fetchLateTimesheets(brickIds, phase.dateFin),
      fetchLateWorklogs(phase.id),
    ]);
    const jiraError = await edgeFunctionData(jira).then(
      () => null,
      (e) => e.message,
    );
    setLateDetails((d) => ({
      ...d,
      [phase.id]: {
        loading: false,
        lines: lines.data || [],
        error: lines.error?.message || null,
        worklogs: jira.data?.worklogs || [],
        domain: jira.data?.domain || null,
        jiraError,
      },
    }));
  }

  async function keepPhaseClosed(phase, heures) {
    const { error } = await setLateHoursSeen(phase.id, heures);
    if (error) return void notify('Erreur enregistrement : ' + error.message);
    update((s) => ({
      ...s,
      clients: s.clients.map((c) => ({
        ...c,
        phases: c.phases.map((ph) => (ph.id === phase.id ? { ...ph, lateHoursSeen: heures } : ph)),
      })),
    }));
  }

  // Même chemin que le dépassement d'une affectation : la nouvelle fin est reportée sur la ligne
  // de l'affaire (dates pilotées par le projet, engagement recalculé).
  async function extendPhase(client, phase, newEnd) {
    await api.extendPhaseEnd(phase, client, newEnd);
    setPhaseEndDialog(null);
    notify(`Phase « ${phase.nom} » prolongée jusqu'au ${fmtDate(newEnd)}.`, 'success');
    await loadLateHours();
  }

  return { loadLateHours, loadLateDetails, keepPhaseClosed, extendPhase };
}
